import apiClient from '@/lib/api-client';
import type { Envelope } from '@/types/quotes';
import type { DeletionPreview, DeletionRequest, DeletionResult, DeletionStatus } from '@/types/accountDeletion';
import { idempotent, unwrap } from './quotes-http';

/**
 * Every call the delete-account screens make (types/accountDeletion.ts says which fields are assumed). The `account_deletion` flag gates the screens;
 * the server answers 404 for every call while it is off.
 */
export const accountDeletionService = {
  /** Whether this business is pending deletion (the banner, the Account page). Any signed-in member. */
  async status(): Promise<DeletionStatus> {
    return unwrap(await apiClient.get<Envelope<DeletionStatus>>('/v1/account/deletion'));
  },
  /** What deleting the business removes. Owner only. */
  async preview(): Promise<DeletionPreview> {
    return unwrap(await apiClient.get<Envelope<DeletionPreview>>('/v1/account/deletion/preview'));
  },
  /** Schedules the business (owner) or removes the login. ONE Idempotency-Key per confirmation, so a double tap or a retry after a lost answer is one request. */
  async request(body: DeletionRequest, idempotencyKey: string): Promise<DeletionResult> {
    return unwrap(await apiClient.post<Envelope<DeletionResult>>('/v1/account/deletion', body, idempotent(idempotencyKey)));
  },
  /** Cancels a pending deletion (any owner), until the purge starts. */
  async cancel(): Promise<void> {
    await apiClient.delete('/v1/account/deletion');
  },
};
